export default "__VITE_ASSET__BbWg04yF__"